import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const LocationSearchBox = styled(Box)`
  width: 100%;
`;